import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestDropdownButton, {
  DropdownButtonProps,
} from 'ext-ui/design-system/generated/latest/components/DropdownButton/DropdownButton'
import GeneratedLiveDropdownButton from 'ext-ui/design-system/generated/live/components/DropdownButton/DropdownButton'
import React, { ReactElement } from 'react'

function renderDesignSystemDropdownButton(
  Component: typeof GeneratedLiveDropdownButton,
  channel: 'live' | 'latest',
  props: DropdownButtonProps,
): ReactElement {
  return <Component {...props} data-design-system-channel={channel} />
}

function LiveDropdownButton(props: DropdownButtonProps): ReactElement {
  return renderDesignSystemDropdownButton(
    GeneratedLiveDropdownButton,
    'live',
    props,
  )
}

function LatestDropdownButton(props: DropdownButtonProps): ReactElement {
  return renderDesignSystemDropdownButton(
    GeneratedLatestDropdownButton,
    'latest',
    props,
  )
}

function DropdownButton(props: DropdownButtonProps): ReactElement {
  const ResolvedDropdownButton = useResolvedDesignSystemComponent(
    LiveDropdownButton,
    LatestDropdownButton,
  )

  return <ResolvedDropdownButton {...props} />
}

export default DropdownButton
export type { DropdownButtonProps }
